import { z } from 'zod';

export const revokeDeviceAuthorizationSchema = z.object({
  device_authorization_id: z.uuid('Valid device authorization ID is required'),
});

export type RevokeDeviceAuthorizationPayload = z.infer<typeof revokeDeviceAuthorizationSchema>;
